import "./workspaceStage.css";

/**
 * Editor stage host. The slide stage always keeps the full workspace size;
 * side panels are rendered as floating overlays on top of it instead of
 * taking width away from the slide.
 *
 *   <WorkspaceStage>
 *     <WorkspaceOverlay side="left" open={...}>panel</WorkspaceOverlay>
 *     <StageArea />
 *     <WorkspaceOverlay side="right" open={...}>panel</WorkspaceOverlay>
 *   </WorkspaceStage>
 */
export default function WorkspaceStage({ children }) {
  return <div className="pm-workspace-stage">{children}</div>;
}

export function WorkspaceOverlay({ side = "left", open = false, label, children }) {
  if (!open) return null;
  return (
    <div className={`pm-workspace-overlay pm-workspace-overlay--${side}`} role="region" aria-label={label}>
      {children}
    </div>
  );
}
